// import { Auth } from 'aws-amplify';
import { call, put, takeEvery, select, takeLatest, takeLeading } from 'redux-saga/effects';
import { AppConstant } from '../App/Assests/AppConstant';
import { modifyTruckData } from '../App/Assests/Utility';
import { convertGmtToDateRange } from '../Utils/DateUtils'
import { Uchain } from '../redux/api/agent';
import {
    initiateGetlist, getListSuccess, getListFailure, updateMainTruckList, getUpdateListSuccess, autoFetchPoListSuccess, updateTruckListSortOrder,
    updateUseCarrierTruckTitleColumn,
    resetAllTruckListData,
    updateUnscheduledList,
    updateScheduledList,
    updateTruckFromSubscription,
    resetSubscriptionUpdateFlag,
    setSubscriptionTruckData
} from '../redux/reducers/reducerSlices/getTruckReducer';
import { getFormattedDate, YYYY_MM_DD_FORMAT } from '../Utils/DateUtils';
import { sagaActions } from './sagaActions';

function* getTruckData() {

    const state = yield select();
    const { taskItemDueSelectedDockFiltersList } = state?.filterReducer;
    const dateRangeObj = state.defaultDashboardReducer.dateRangeObj;
    const start = convertGmtToDateRange(dateRangeObj).start;
    const end = convertGmtToDateRange(dateRangeObj).end;
    // If user is redirecting from task item due, we check if any selected dock, if yes then we pass dock id here else null
    let dockIdArray = []
    if (taskItemDueSelectedDockFiltersList && taskItemDueSelectedDockFiltersList.length) {
       dockIdArray = taskItemDueSelectedDockFiltersList.map(el => el.dock_id)
    }
    const isWorkdayWarehouse = state?.userReducer?.selectedWarehouse?.operationType === 'WORKDAY';
    const isWorkDay = state.defaultDashboardReducer.isWorkDay;

    const validFromDate =
        !isWorkdayWarehouse || (isWorkdayWarehouse && !isWorkDay) ? start !== "Invalid date" ? start : null : null;

    const validToDate =
        !isWorkdayWarehouse || (isWorkdayWarehouse && !isWorkDay) ? end !== "Invalid date" ? end : null : null;
    

    const data = {

        "warehouse_id": state.userReducer.selectedWarehouse.ID,

        "dock_id":  dockIdArray.length ? dockIdArray.toString(): null,

        "carrier": null,

        "vendor": null,

        "is_task_item": state.defaultDashboardReducer.selectedTaskItem,

        "fromDate": validFromDate,
        
        "toDate": validToDate,

    }

    try {
        const { arrangeOrder, arrangeKey } = state.getTruckReducer
        const arrange = {
            order: arrangeOrder,
            key: arrangeKey
        }
        const response = yield call(Uchain.getTruck, data);
        let modifyTruckList = modifyTruckData(response, arrange);
        const newResponse = {
            truckList: modifyTruckList,
            truckListMasterData: modifyTruckList
        }
        yield put(updateMainTruckList(newResponse));
        yield put(getListSuccess(newResponse));

    } catch (error) {
        /* Auto Fetch PO-List - if Auto Fetch Fails then it shoud not clear data already on screen*/
        const autoFetchPolist = state.getTruckReducer.autoFetchPolist
        if (!autoFetchPolist) {
            // yield put(getListFailure());
        }
    }
}


/* function* loadMoreTruckList() {
    try {
        const newData = poData;
        newData.currentPage = newData.currentPage + 1
        newData.poList = [...newData.truckList, ...newData.truckList]
        const response = yield call(data);
        yield put(getListSuccess(poData));

    } catch (error) {
        //   yield put(clearList());
    }
}
 */
function* initateLoader() {
    try {
        yield put(initiateGetlist())
    } catch (error) {
        yield put(getListFailure());

    }
}

function* updateTruck(data) {
    try {
        const newResponse = {
            truckList: data.payload,
        }
        yield put(getUpdateListSuccess(newResponse));
    } catch (error) {
        yield put(getListFailure());
    }
}

function* autoFetchPoListHandler(data) {
    try {
        yield put(autoFetchPoListSuccess(data.payload));
    } catch (error) {
        yield put(autoFetchPoListSuccess(false));
    }
}

function* sortPoListHandler(data) {
    try {
        yield put(updateTruckListSortOrder(data.payload));
    } catch (error) {
    }
}

export function* initiateTruckLoader() {
    yield takeLatest(sagaActions.INTAITE_GET_TRUCK, initateLoader)
}

export function* getTruck() {
    yield takeLatest(sagaActions.FETCH_TRUCK_LIST, getTruckData)
}

export function* updateTruckList() {

    yield takeLatest(sagaActions.UPDATE_TRUCK, updateTruck)
}

export function* autoFetchPoList() {
    yield takeLatest(sagaActions.AUTO_FETCH_PO_LIST, autoFetchPoListHandler)
}

export function* sortPoList() {
    yield takeLatest(sagaActions.SORT_TRUCK_LIST, sortPoListHandler)
}


function* updateUseCarrierTruckTitleColumnSaga(data) {
    try {
        yield put(updateUseCarrierTruckTitleColumn(data.payload));
    } catch (error) {
    }
}

export function* updateUseCarrierTruckTitleColumnWatcher() {
    yield takeLatest(sagaActions.UPDATE_TRUCK_COLUMN_TITLE_USE_CARRIER, updateUseCarrierTruckTitleColumnSaga)
}


function* resetAllTruckListSaga() {
    try {
        yield put(resetAllTruckListData());
    } catch (error) {
        yield put(resetAllTruckListData());
    }
}

export function* resetAllTruckListWatcher() {
    yield takeLatest(sagaActions.RESET_TRUCK_DATA, resetAllTruckListSaga)
}


function* updateSchduledListSaga(data) {
    try {
        yield put(updateScheduledList(data.payload));
    } catch (error) {
        yield put(updateScheduledList([]));
    }
}
export function* updateSchduledListWatcher() {

    yield takeLatest(sagaActions.UPDATE_SCHEDULED_TRUCK, updateSchduledListSaga)
}

function* updateUnSchduledListSaga(data) {
    try {
        yield put(updateUnscheduledList(data.payload));
    } catch (error) {
        yield put(updateUnscheduledList([]));
    }
}

export function* updateUnSchduledListWatcher() {

    yield takeLatest(sagaActions.UPDATE_UNSCHEDULED_TRUCK, updateUnSchduledListSaga)
}

function* updateTruckFromSubscriptionSaga(data) {
    try {
        const state = yield select();
        const selectedTaskItem = state.defaultDashboardReducer.selectedTaskItem;
        if (selectedTaskItem) {
            // if there is taskItemdue filter the we refetch data rather than updating list, we will
            // enhance this logic later
            yield put(resetSubscriptionUpdateFlag({payload: true}))
            yield put({ type: sagaActions.FETCH_TRUCK_LIST, payload: '' });
        } else {
            yield put(updateTruckFromSubscription(data.payload));
        }
    } catch (error) {
   
    }
        
}

export function* updateTruckFromSubscriptionWatcher() {
    yield takeLatest(sagaActions.UPDATE_TRUCK_FROM_SUBSCRIPTION, updateTruckFromSubscriptionSaga);
}


function* resetSubscriptionFlagSaga(data) {
    try {
        yield put(resetSubscriptionUpdateFlag(data.payload));
    } catch (error) {
    }
        
}

export function* resetSubscriptionFlagWatcher() {
    yield takeLatest(sagaActions.RESET_SUBSCRIPTION_UPDATE_FLAG, resetSubscriptionFlagSaga);
}

function* setTruckDataFromSubscriptionSaga(data) {
    try {
        if (data?.payload) {
            yield put(setSubscriptionTruckData(data?.payload));
        } else {
            yield put(setSubscriptionTruckData({}));
        }
    } catch (error) {
        yield put(setSubscriptionTruckData({}));
    }
        
}

export function* setTruckDataFromSubscriptionWatcher() {
    yield takeLatest(sagaActions.SET_TRUCK_DATA_FROM_SUBSCRIPTION, setTruckDataFromSubscriptionSaga);
}
/* export function* loadMoreTruck() {
    yield takeEvery(sagaActions.LOAD_MORE_TRUCK_LIST, loadMoreTruckList)
} */
